import gql from 'graphql-tag';
export default gql`
  fragment orderItemInfo on OrderItem {
    id
    product {
      id
      code
      name
      barcode
      eans {
        id
        ean
      }
    }
    quantity
    deliveredQuantity
    discountedPrice
    discount1
    discount2
    discount3
    price
    cenaCenovnikBezPDV
    cenaCenovnikSaPDV
    krajnjaCenaBezPDV
    krajnjaCenaSaPDV
    tarifnaGrupa
  }
`;